export const linkDefaultProps = {
    size: 'caption',
    variant: 'main',
};
